/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./countUp.vue?vue&type=template&id=c6458ae6&scoped=true"
import script from "./countUp.vue?vue&type=script&lang=js"
export * from "./countUp.vue?vue&type=script&lang=js"
import style0 from "./countUp.vue?vue&type=style&index=0&id=c6458ae6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6458ae6",
  null
  
)

export default component.exports